export const trimStringToNearestWord = (string: string, maxChar: number = 10) => {
    if (string.length <= maxChar) return string;
    return string.substr(0, string.lastIndexOf(' ', maxChar));
}
//https://stackoverflow.com/questions/5454235/shorten-string-without-cutting-words-in-javascript